import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/subscription/success-trial")({
  head: () => seoHead({
    title: "Trial Unlocked",
    description: "Your LeadXkids trial course is unlocked.",
    noindex: true,
  }),
  component: () => <SubscriptionSuccess variant="trial" />,
});
